import { get, unescape } from 'lodash'
import styled, { css } from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledCategory = styled.div`
  font-weight: bold;
  font-size: ${(props: any) => get(props.theme, 'fontSizes.small')}px;
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, `category.${props.priority}.color`)};
  padding: 5px 10px;
  text-transform: uppercase;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  display: inline-block;
  line-height: 1;
  ${(props: any) => {
    if (get(props.theme, `category.${props.priority}.format`) === 'outline') {
      return css`
        border: 1px solid ${themeUtilities.getRgbaColor(props.theme, `category.${props.priority}.color`)};
      `
    } else {
      return css`
        background-color: ${themeUtilities.getRgbaColor(props.theme, `category.${props.priority}.backgroundColor`)};
      `
    }
  }}
`

interface CategoryProps {
  category: string
  className?: string
  priority: string
}

function Category({ category, priority, className }: CategoryProps) {
  if (!category || !priority) {
    return null
  }

  return (
    // @ts-expect-error
    <StyledCategory className={className} priority={priority}>
      {unescape(category)}
    </StyledCategory>
  )
}

Category.displayName = 'Category'

export default Category
